import { SET_LXW_LOCALSTORAGE_VALUE } from "../actions/types";

const initialState = {
	sidenavExpanded: true,
	matterInfoHidden: false,
	whatsNewDropdownLastHashViewed: 0,
	inlineCompareUrl: "",
	dropdownSelectShowAll: {
		users: false,
	},
	recentlyViewedMatters: [],
	recentlyViewedClients: [],
	newDocumentProfilingExpanded: true,
	mandatoryProfilingDialogBulkProcessingExpanded: true,
	topMattersSearchResultsExpanded: true,
	aiGroupSourcesByMessage: true,
	aiCitationsSidebarCollapsed: false,
	passwordProtectShare: false,
	developerObjectInfoSections: ["database", "s3", "search"],
	developerObjectInfoS3View: "flat",
	developerObjectInfoShowAllFields: false,
	developerObjectInfoFriendlyDates: false,
	documentListShowTrash: false,
	documentListShowArchive: false,
	showTrashMatters: false,
	showArchiveMatters: false,
	showTrashClients: false,
	developerObjectInfoTruncate: true,
	matterListShowArchived: false,
	matterListShowInTrash: false,
	developerObjectInfoDbSections: [
		"Documents",
		"Folders",
		"DocumentVersionCounters",
		"DocumentVersions",
		"DocumentVersionLabels",
		"DocumentMajorVersions",
		"Emails",
		"Notes",
	],
};

export default function (state = initialState, action) {
	switch (action.type) {
		case SET_LXW_LOCALSTORAGE_VALUE: {
			const { key, value } = action.payload;

			return { ...state, [key]: value };
		}
		default:
			return state;
	}
}
